import { assign } from "xstate";
import { ProductOpaqueValue } from "@b2bportal/purchase-api";

import {
  cartHelpers,
  ContactSelectors,
  ParentState,
  setContextWithKey,
} from "@capone/checkout";
import { CreateActivityProductRequest } from "redmond";

import { ActivityMachineContext } from "../types";
import {
  getActivityShop,
  getActivityPriceBreakdown,
  getActivityTravelerCounts,
} from "../selectors/activity";
import { getPaxMixFromTravelersCount } from "../../../common";

const addActivityProduct = assign((context: ActivityMachineContext) => {
  const shopDetails = getActivityShop({ context });
  const priceBreakdown = getActivityPriceBreakdown({ context });
  const travelerCounts = getActivityTravelerCounts({ context });

  const contactInformationEmail = ContactSelectors.getEmailAddress({
    context,
  });

  if (!shopDetails || !priceBreakdown) {
    throw new Error("Missing shop response or price breakdown");
  }

  if (!travelerCounts) {
    throw new Error("Missing traveler counts");
  }

  const activityProductValue: CreateActivityProductRequest = {
    opaqueShoppedProduct: priceBreakdown?.opaqueShoppedProduct,
    startTime: priceBreakdown?.startTime,
    experienceOptionId: priceBreakdown?.optionId,
    date: priceBreakdown?.date || "",
    experienceId: shopDetails.id,
    paxMix: getPaxMixFromTravelersCount(travelerCounts),
  };

  const productType = "Activities";

  const activityProduct = {
    type: productType,
    value: activityProductValue,
  } as unknown as ProductOpaqueValue;

  const ctxWithActivity = cartHelpers.addQuoteProduct(activityProduct, context);

  return setContextWithKey(
    ctxWithActivity,
    `${ParentState.cartQuote}.customerEmail`,
    contactInformationEmail
  );
});

export default addActivityProduct;
